import { Navigate } from 'react-router-dom'
import { useMappingIndex } from 'app/components/mapping-index/useMappingIndex'
import { MappingIndexComponent } from 'app/components/mapping-index/MappingIndexComponent'
import { useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'

export default function Index() {
  const user = useUser()

  if (!user) return <></>
  const target = isSMCOrg(user.orgId) ? `/settings/mapping/referral` : `/settings/mapping/channels`
  return <Navigate to={target} replace />
}
